module.exports = __webpack_public_path__ + "static/media/tomato.3d6d8c30.svg";